"use client";

import dynamic from "next/dynamic";

const FloatingMediaLazy = dynamic(() => import("./FloatingMedia").then(mod => mod.FloatingMedia));

export default FloatingMediaLazy;
